import React from "react";
import format from "date-fns/format";
import PropTypes from "prop-types";
// Material imports
import Typography from "@mui/material/Typography";
const TimePosted = ({
  time
}) => {
  const formattedTime = format(new Date(time), "H:mm");
  return /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "textSecondary",
    style: {
      minWidth: 50
    }
  }, formattedTime);
};
export default TimePosted;
TimePosted.propTypes = {
  time: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};